"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const either_1 = require("../../types/either");
const projectHelpers_1 = require("../../utils/projectHelpers");
const updateProjectProductOptions_1 = require("./updateProjectProductOptions");
function default_1(project, art, timestamp, product) {
  const newOptions = (0, projectHelpers_1.fixProductOptions)(project, art);
  const updateProjectProductOptionsResult = (0, updateProjectProductOptions_1.updateProjectProductOptions)({
    project,
    art,
    timestamp,
    product,
    newOptions
  });
  if (updateProjectProductOptionsResult.isLeft()) {
    return (0, either_1.left)(updateProjectProductOptionsResult.value);
  } else {
    return (0, either_1.right)(updateProjectProductOptionsResult.value);
  }
}